import { LocalStorage } from '@/utils/LocalStorage';
import { useNavigate } from 'react-router-dom';
import * as P from '@/constants/paths';
import useRegisterStore, { RegistrationTrack } from '../useRegistrationStore';

const useRegisterRouteSafety = () => {
  const navigate = useNavigate();
  const { restrictedRegistrationSteps } = useRegisterStore();
  const checkTheRouteAndRegisterStore = (currentStep: RegistrationTrack) => {
    const registerStore = LocalStorage.getItem('register');
    if (!registerStore) {
      navigate(P.REGISTRATION_LANDING);
    }
    if (registerStore && restrictedRegistrationSteps.includes(currentStep)) {
      navigate(-1);
    }
  };

  return {
    checkTheRouteAndRegisterStore,
  };
};

export default useRegisterRouteSafety;
